<template>
  <v-card class="menu-card">
    <v-card-title class="d-flex justify-space-between align-center py-4">
      <div class="d-flex align-center">
        <v-icon color="primary" class="mr-3">mdi-food</v-icon>
        <div>
          <span class="text-h6 font-weight-bold">{{ menu.name }}</span>
          <v-chip size="small" color="primary" variant="tonal" class="ml-3">
            Choice of {{ menu.choiceOf }}
          </v-chip>
        </div>
      </div>
      <div class="d-flex" style="gap: 8px;">
        <v-btn icon variant="text" size="small" @click="$emit('edit-menu', menu)">
          <v-icon size="20">mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon variant="text" size="small" color="error" @click="$emit('delete-menu', menu.id)">
          <v-icon size="20">mdi-delete</v-icon>
        </v-btn>
      </div>
    </v-card-title>
    <v-card-subtitle v-if="menu.tacoBarIncludes" class="pb-2">
      {{ menu.tacoBarIncludes }}
    </v-card-subtitle>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="menu.deliveryOptions"
        item-key="id"
        density="comfortable"
      >
        <template #item.price="{ item }">
          <span class="font-weight-medium">${{ item.price.toFixed(2) }}</span>
        </template>
      </v-data-table>
    </v-card-text>
    <div v-if="menu.addonPackages && menu.addonPackages.length" class="pa-4 pt-2">
      <span class="text-caption text-medium-emphasis text-uppercase font-weight-bold">Addon Packages:</span>
      <div class="d-flex flex-wrap mt-1" style="gap: 6px;">
        <v-chip
          v-for="pkg in menu.addonPackages"
          :key="pkg.id"
          size="small"
          color="teal"
          variant="tonal"
        >
          {{ pkg.name }}
        </v-chip>
      </div>
    </div>
  </v-card>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  menu: {
    type: Object,
    required: true,
  },
});

const headers = [
  {
    title: "Name",
    value: "name",
    align: "start",
    sortable: false,
    width: "100%",
  },
  {
    title: "Price",
    value: "price",
    align: "start",
    sortable: false,
    width: "100px",
  },
];
</script>

<style scoped>
.menu-card {
  transition: all 0.2s ease;
}

.menu-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background-color: #f8fafc;
}

:deep(.v-data-table-header th) {
  font-weight: 600 !important;
  text-transform: uppercase;
  font-size: 0.75rem !important;
  letter-spacing: 0.5px;
  color: #64748b !important;
}
</style>
